import { useMemo } from 'react';

export function useBelotPhaseManager({ engineState, humanSeat }) {
  return useMemo(() => {
    const phase = engineState?.phase ?? 'init';
    const currentTurnSeat = engineState?.currentTurnSeat;
    const isHumanAuctionTurn = phase === 'auction' && currentTurnSeat === humanSeat;
    const isHumanPlayTurn = phase === 'play' && currentTurnSeat === humanSeat;
    const inDeclare = phase === 'declare';
    const roundIdle = phase === 'dealing';
    const matchDone = phase === 'match_end';

    let phaseLabel = phase;
    if (phase === 'init') phaseLabel = 'Ожидание';
    else if (phase === 'auction') phaseLabel = 'Торги';
    else if (phase === 'declare') phaseLabel = 'Комбинации';
    else if (phase === 'play') phaseLabel = `Взятка ${engineState?.trickIndex ?? 0}/8`;
    else if (phase === 'dealing') phaseLabel = 'Между раундами';
    else if (phase === 'match_end') phaseLabel = 'Матч окончен';

    return {
      phase,
      phaseLabel,
      isHumanAuctionTurn,
      isHumanPlayTurn,
      inDeclare,
      roundIdle,
      matchDone,
    };
  }, [engineState, humanSeat]);
}

